import React, {useState} from "react";
import "./Swipeable.scss";
import SwipeableHook from "../../../../hoc/Swipeable";


const Swipeable = ({
            title = "",
            previewUrl = "",
            handleDeclined = ()=>{},
            handleConfirmed = ()=>{},
            delta = 20,
            labelGender = "",
            classGender = "",
            classBorderGender = ""
       }) => {

    const [classCss, setClassCss] = useState("");

    return (
        <SwipeableHook
            className={`swipeable ${classCss ? classCss : ""}`}
            paramsSwipe={
                {
                    delta : {  left : delta ,  right : delta  },
                    onSwipedLeft: () => {
                        if(classCss !==""){
                            handleConfirmed();
                            setClassCss("");
                        }

                    },
                    onSwipedRight: () => {
                        if(classCss !=="") {
                            handleDeclined();
                            setClassCss("");
                        }
                    },
                    preventDefaultTouchmoveEvent: true,
                    onSwiping: (value) => {
                        if(value.deltaX > delta && classCss !== "incorrect"){
                            setClassCss("incorrect");
                        }
                        else if(value.deltaX < (0 - delta) && classCss !== "correct"){
                            setClassCss("correct");
                        }
                        else if(value.deltaX >= (0 - delta) && value.deltaX <= delta && classCss !== ""){
                            setClassCss("");
                        }
                    },

                    trackMouse: false
                }
            }
        >
            <div className={`thumbnail ${classBorderGender}`}>
                {labelGender ? <div className={`gender ${classGender}`}>Profil {labelGender}</div> : null}
                <img alt={title} src={`${previewUrl}?height=350`} />
            </div>
        </SwipeableHook>
    )
}

export default Swipeable;